// =============================================================================
// clientes/src/lib/supabase.ts — o cliente da API, para o PARCEIRO.
//
// storageKey PRÓPRIA ('serginho-clientes-auth'): se um dia alguém da loja
// abrir o portal no mesmo navegador do sistema, as duas sessões não se
// atropelam. Em dev a URL fica vazia e cai na própria origem — o proxy do
// vite.config encaminha para a stack de dev (zero CORS).
// =============================================================================
import { createClient } from '@supabase/supabase-js';

const url = (import.meta.env.VITE_SUPABASE_URL as string | undefined)
  || window.location.origin;
const anonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? '';

export const configurado = Boolean(anonKey);

export const supabase = createClient(url, anonKey || 'sem-configuracao', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'serginho-clientes-auth',
  },
});

/** A base pública das fotos (rota /imagens do Caddy — sem token). */
export const urlDaFoto = (productId: string) => `${url}/imagens/pecas/${productId}`;

/** Erros do PostgREST/GoTrue em português de gente. */
export function mensagemDeErro(erro: unknown): string {
  const m = erro instanceof Error ? erro.message : String(erro);
  if (/Invalid login credentials/i.test(m)) return 'E-mail ou senha errados.';
  if (/Failed to fetch|NetworkError|Load failed/i.test(m)) {
    return 'Sem conexão com o servidor. Verifique a internet e tente de novo.';
  }
  if (/JWT|token|expirad/i.test(m)) return 'Sessão expirada — entre de novo.';
  return m;
}
